import { apiFetch } from "../api/client";

export async function checkMissingSelections({ user, summaryId, requiredCategories }) {
  if (!user || !summaryId) return [];

  try {
    const selected = await apiFetch(`/form/summary/${summaryId}/selections`, {
      token: user.token,
    });

    const selectedCategories = new Set(selected.map((sel) => sel.category_name));

    const missing = requiredCategories.filter((cat) => !selectedCategories.has(cat.label));

    return missing;
  } catch (error) {
    console.error("Error checking missing selections:", error);
    return [];
  }
}

export async function fetchRequiredCategories({ user, parentCategory }) {
  if (!parentCategory) return [];

  const categories = await apiFetch(
    `/form/categories/by-parent?name=${encodeURIComponent(parentCategory)}`,
    { token: user.token }
  );

  return categories.map((cat) => ({
    id: cat.id,
    label: cat.label,
    page: parentCategory,
  }));
}
